module.exports = __webpack_public_path__ + "static/img/10.48254d8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/2/zh/10.png
// module id = VOXV
// module chunks = 0